import type { ReactNode } from "react";

interface ItemProps {
  index: number;
  children: Readonly<ReactNode>
}

export default function Item({  children } : ItemProps) {
  return (
    <div
      className="z-10 h-full"
    >
      <div className="cursor-default h-full card p-8 rounded-3xl">
        {children}
      </div>
    </div>
  );
}
